import styled from 'styled-components';
import { layout } from 'src/components/base';
import { FontWeight } from '@prisjakt/ui/text';
import { Link } from 'react-router-dom';

export const StoreReviews = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${layout.measurements.spacing025};
`;

export const StoreLink = styled(Link)`
  font-size: ${layout.measurements.fontSizeNormal};
  font-weight: ${FontWeight.HEAVIER};
  color: ${p => p.theme.text.callToAction};
  :hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const Separator = styled.span`
  margin: 0 ${layout.measurements.spacing025};
`;
